import Axios from '@/services/axios'
import msg from '@/common/msg'

export default {
  postTrackLog (params, customHeaders = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'salmon/events',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.status !== 201) {
            reject(response.data.header.message)
          }
          resolve(response.data.header)
        },
        error => {
          reject(error)
        },
        customHeaders
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/eventservice.js